import { graphql } from 'react-relay';

export const surveySubmit = graphql`
  mutation submitSurveyMutation($surveyAnswerId: String!) {
    submitSurvey(surveyAnswerId: $surveyAnswerId) {
      result
      errors {
        code
        message
      }
    }
  }
`;
